// extracted by mini-css-extract-plugin
module.exports = {"activeClass":"VehicleWithdrawalFormModal_activeClass_14MBp"};